import { cn } from '@/lib/utils';

/** The active entry's leading line, for a row that keeps its own layout (a
 *  workflow under Workflows) but must mark "you are here" the same way. The
 *  row must be positioned (`relative`). */
export const NAV_ACTIVE_LINE =
  "data-[status=active]:before:absolute data-[status=active]:before:inset-y-2 data-[status=active]:before:left-0 data-[status=active]:before:w-0.5 data-[status=active]:before:rounded-full data-[status=active]:before:bg-[var(--nav-active-line,var(--color-accent-line))] data-[status=active]:before:content-['']";

/**
 * One look for a rail's destination in every shell — a workspace, Your settings,
 * the organization console (spec 167) — so moving between them never changes
 * what "you are here" looks like.
 *
 * Interaction states use surface, weight and the focus ring, plus the 2px line
 * at the leading edge of the active entry (spec 122 FR-012): a fill, which
 * FD-13 allows where the colour as text is not. The line's colour is the
 * rail's to choose through `--nav-active-line`, so the console can draw it in
 * its Turquoise; everywhere else it is Light Blue. Its shape — short, rounded,
 * inset from the entry's top and bottom — is the same in every shell.
 *
 * The brand palette ships twelve flat values and no tint ramp, and deriving a
 * hover or selected blue is a merge blocker (docs/brand.md FD-12 / OD-10). If
 * this reads as too subtle, the fix is to obtain the tint ramp, not to pick a
 * shade.
 */
export function navItemClasses({
  collapsed = false,
  className,
}: { collapsed?: boolean; className?: string } = {}) {
  return cn(
    'group relative flex items-center gap-2.5 rounded-md px-2.5 py-2 text-sm',
    'text-sidebar-foreground/80 transition-colors',
    NAV_ACTIVE_LINE,
    'hover:bg-sidebar-accent hover:text-sidebar-accent-foreground',
    'focus-visible:ring-sidebar-ring focus-visible:ring-3 focus-visible:outline-none',
    'data-[status=active]:bg-sidebar-accent data-[status=active]:text-sidebar-accent-foreground data-[status=active]:font-medium',
    collapsed && 'justify-center px-0',
    className,
  );
}
